import React, { useState } from 'react';
import { ChevronDown, Paperclip } from 'lucide-react';
import FileLink from '../FileLink';

export default function MilestoneFiles({ files = [] }) {
  const [expanded, setExpanded] = useState(false);
  const visibleFiles = expanded ? files : files.slice(0, 6);
  const hiddenCount = files.length - visibleFiles.length;

  if (files.length === 0) return null;

  return (
    <div className="milestone-attachments">
      <div className="milestone-attachments-heading">
        <span><Paperclip size={13} /> Attachments</span>
        <span>{files.length}</span>
      </div>
      <div className="milestone-file-grid">
        {visibleFiles.map((file, index) => (
          <FileLink key={file._id || file.id || index} file={file} iconSize={13} className="milestone-file-item" />
        ))}
      </div>
      {files.length > 6 && (
        <button type="button" className="milestone-files-toggle" onClick={() => setExpanded((value) => !value)}>
          <ChevronDown size={14} className={expanded ? 'expanded' : ''} />
          {expanded ? 'Show fewer files' : `Show ${hiddenCount} more`}
        </button>
      )}
    </div>
  );
}
